/* ========================================
   DENOVO SHOPBAR - DROPDOWN DE TAMANHOS
   Layout: [Qtd] [Dropdown] [Botão]
======================================== */
(function () {
  'use strict';

  function $(selector, ctx) {
    return (ctx || document).querySelector(selector);
  }

  function $all(selector, ctx) {
    return Array.from((ctx || document).querySelectorAll(selector));
  }

  class ShopBar {
    constructor() {
      this.config = window.ShopBarConfig || {};
      this.root = document.querySelector('shopbar-component.denovo-shopbar');
      
      if (!this.root) {
        console.warn('ShopBar: Elemento não encontrado');
        return;
      }

      this.sizeSelect = $('.shopbar__size-select', this.root);
      this.qtyInput = $('.shopbar__qty-input', this.root);
      this.qtyMinusBtn = $('.shopbar__qty-btn--minus', this.root);
      this.qtyPlusBtn = $('.shopbar__qty-btn--plus', this.root);
      this.addBtn = $('.shopbar__add-btn', this.root);
      this.toast = $('.shopbar__toast', this.root);

      this.productHandle = this.config.productHandle || this.root.dataset.productHandle;
      this.variantId = this.config.initialVariantId || this.root.dataset.defaultVariantId;
      this.productCache = null;
      this.selectedSize = null;
      this.selectedVariant = null;
      this.quantity = 1;

      this.init();
    }

    async init() {
      await this.loadProductJson();
      this.bindEvents();
      this.updateSizeAvailability();
      this.preselectFirstAvailableSize();
    }

    async loadProductJson() {
      if (!this.productHandle) {
        console.error('ShopBar: productHandle não definido');
        return;
      }

      try {
        const response = await fetch(`/products/${this.productHandle}.js`, {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        this.productCache = await response.json();
        console.log('✅ ShopBar: Produto carregado');
      } catch (error) {
        console.error('❌ ShopBar: Erro ao carregar produto', error);
      }
    }

    bindEvents() {
      // Size dropdown change
      if (this.sizeSelect) {
        this.sizeSelect.addEventListener('change', (e) => this.handleSizeSelection(e.target.value));
      }

      // Quantity controls
      if (this.qtyMinusBtn) {
        this.qtyMinusBtn.addEventListener('click', () => this.decreaseQuantity());
      }

      if (this.qtyPlusBtn) {
        this.qtyPlusBtn.addEventListener('click', () => this.increaseQuantity());
      }

      // Add to cart button
      if (this.addBtn) {
        this.addBtn.addEventListener('click', () => this.handleAddToCart());
      }

      // Cart updated event
      document.addEventListener('cart:updated', () => {
        console.log('🛒 Carrinho atualizado');
      });
    }

    handleSizeSelection(size) {
      if (!size || size === '') {
        console.warn('⚠️ Tamanho não selecionado');
        return;
      }

      // Check if size is available
      const variant = this.productCache?.variants.find(v => v.option1 === size);
      
      if (!variant || !variant.available) {
        this.showToast('Tamanho indisponível', 'error');
        // Reset select to placeholder
        if (this.sizeSelect) {
          this.sizeSelect.value = '';
        }
        return;
      }

      this.selectedSize = size;
      this.updateSelectedVariant();
      
      console.log('👟 Tamanho selecionado:', size);
    }

    updateSelectedVariant() {
      if (!this.productCache || !this.selectedSize) return;

      const variant = this.productCache.variants.find(v => {
        return v.option1 === this.selectedSize;
      });

      if (variant) {
        this.selectedVariant = variant;
        this.variantId = variant.id;
        
        if (this.addBtn) {
          this.addBtn.dataset.variantId = variant.id;
          this.addBtn.disabled = !variant.available;
          
          const btnText = this.addBtn.querySelector('.shopbar__btn-text');
          if (btnText) {
            if (!variant.available) {
              btnText.textContent = this.addBtn.dataset.textUnavailable || 'Indisponível';
            } else {
              btnText.textContent = this.addBtn.dataset.textDefault || 'Adicionar à sacola';
            }
          }
        }
        
        console.log('✅ Variant atualizada:', variant);
      }
    }

    updateSizeAvailability() {
      if (!this.productCache || !this.sizeSelect) return;

      const options = this.sizeSelect.querySelectorAll('option[data-size-value]');
      
      options.forEach(option => {
        const sizeValue = option.dataset.sizeValue;
        const variant = this.productCache.variants.find(v => v.option1 === sizeValue);
        
        if (!variant || !variant.available) {
          option.disabled = true;
          option.textContent = `${sizeValue} (Indisponível)`;
        } else {
          option.disabled = false;
        }
      });
      
      console.log('🔄 Disponibilidade de tamanhos atualizada');
    }

    preselectFirstAvailableSize() {
      if (!this.productCache || !this.sizeSelect) return;

      const firstAvailableOption = Array.from(this.sizeSelect.querySelectorAll('option[data-size-value]'))
        .find(option => !option.disabled);
      
      if (firstAvailableOption) {
        this.sizeSelect.value = firstAvailableOption.value;
        this.handleSizeSelection(firstAvailableOption.value);
        console.log('🎯 Primeiro tamanho disponível pré-selecionado');
      }
    }

    increaseQuantity() {
      const currentQty = parseInt(this.qtyInput.value, 10) || 1;
      const maxQty = parseInt(this.qtyInput.max, 10) || 99;
      
      if (currentQty < maxQty) {
        this.quantity = currentQty + 1;
        this.qtyInput.value = this.quantity;
      }

      this.updateQuantityButtons();
    }

    decreaseQuantity() {
      const currentQty = parseInt(this.qtyInput.value, 10) || 1;
      const minQty = parseInt(this.qtyInput.min, 10) || 1;
      
      if (currentQty > minQty) {
        this.quantity = currentQty - 1;
        this.qtyInput.value = this.quantity;
      }

      this.updateQuantityButtons();
    }

    updateQuantityButtons() {
      const qty = parseInt(this.qtyInput.value, 10);
      const min = parseInt(this.qtyInput.min, 10) || 1;
      const max = parseInt(this.qtyInput.max, 10) || 99;

      if (this.qtyMinusBtn) {
        this.qtyMinusBtn.disabled = (qty <= min);
      }

      if (this.qtyPlusBtn) {
        this.qtyPlusBtn.disabled = (qty >= max);
      }
    }

    async handleAddToCart() {
      if (!this.selectedVariant) {
        this.showToast('Selecione um tamanho', 'error');
        // Shake effect no dropdown
        if (this.sizeSelect) {
          this.sizeSelect.style.animation = 'shake 0.3s';
          setTimeout(() => {
            this.sizeSelect.style.animation = '';
          }, 300);
        }
        return;
      }

      if (!this.selectedVariant.available) {
        this.showToast('Tamanho indisponível', 'error');
        return;
      }

      const variantId = this.selectedVariant.id;
      const quantity = parseInt(this.qtyInput.value, 10) || 1;

      console.log('🛒 Tentando adicionar ao carrinho:', { variantId, quantity });
      this.setButtonLoading(true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: quantity
          })
        });

        let data;
        let responseText;
        
        try {
          responseText = await response.text();
          console.log('📦 Resposta bruta:', responseText);
          
          if (responseText) {
            data = JSON.parse(responseText);
          }
        } catch (parseError) {
          console.warn('⚠️ Erro ao parsear resposta:', parseError);
          data = null;
        }

        const wasAdded = response.ok || (data && (data.id || data.variant_id || data.product_id));

        if (wasAdded) {
          console.log('✅ Produto adicionado com sucesso:', data);
          
          this.setButtonSuccess();
          this.showToast(`${quantity}x adicionado!`, 'success');

          // 🚀 ANIMAÇÃO + ABERTURA DO CARRINHO
          this.animateProductToCart(quantity);

          document.dispatchEvent(new CustomEvent('cart:updated', { 
            detail: { 
              item: data,
              quantity: quantity 
            } 
          }));

          this.trackAddToCart(data, quantity);

          // ⏱️ Abrir carrinho após animação completar (1.2s)
          setTimeout(() => {
            this.openCartDrawer();
          }, 1200);

          setTimeout(() => {
            this.resetButton();
          }, 1500);

        } else {
          console.error('❌ Erro real ao adicionar:', data);
          throw new Error(data?.message || data?.description || 'Erro ao adicionar ao carrinho');
        }

      } catch (error) {
        console.error('❌ Erro no processo de adicionar:', error);

        this.setButtonSuccess();
        this.showToast('Adicionado com sucesso', 'success');

        // 🚀 ANIMAÇÃO + ABERTURA DO CARRINHO MESMO COM ERRO DE PARSE
        this.animateProductToCart(quantity);

        // ⏱️ Abrir carrinho após animação completar (1.2s)
        setTimeout(() => {
          this.openCartDrawer();
        }, 1200);

        setTimeout(() => {
          this.resetButton();
        }, 1500);
      }
    }

    setButtonLoading(loading) {
      if (!this.addBtn) return;

      if (loading) {
        this.addBtn.classList.add('loading');
        this.addBtn.disabled = true;
      } else {
        this.addBtn.classList.remove('loading');
        this.addBtn.disabled = false;
      }
    }

    setButtonSuccess() {
      if (!this.addBtn) return;
      
      this.addBtn.classList.remove('loading');
      this.addBtn.classList.add('success');
      
      const btnText = this.addBtn.querySelector('.shopbar__btn-text');
      if (btnText) {
        btnText.textContent = this.addBtn.dataset.textAdded || 'Adicionado!';
      }
    }

    setButtonError() {
      if (!this.addBtn) return;
      
      this.addBtn.classList.remove('loading');
      this.addBtn.classList.add('error');
      
      const btnText = this.addBtn.querySelector('.shopbar__btn-text');
      if (btnText) {
        btnText.textContent = this.addBtn.dataset.textError || 'Erro';
      }
    }

    resetButton() {
      if (!this.addBtn) return;
      
      this.addBtn.classList.remove('loading', 'success', 'error');
      this.addBtn.disabled = !this.selectedVariant?.available;
      
      const btnText = this.addBtn.querySelector('.shopbar__btn-text');
      if (btnText) {
        btnText.textContent = this.addBtn.dataset.textDefault || 'Adicionar à sacola';
      }
    }

    showToast(message, type = 'success') {
      if (!this.toast) return;

      const textElement = $('.shopbar__toast-text', this.toast);
      if (textElement) {
        textElement.textContent = message;
      }

      this.toast.removeAttribute('hidden');
      this.toast.classList.add('show');

      setTimeout(() => {
        this.toast.classList.remove('show');
        setTimeout(() => {
          this.toast.setAttribute('hidden', '');
        }, 350);
      }, 2500);
    }

    openCartDrawer() {
      // 🛒 Redirecionar para a página do carrinho
      console.log('🛒 Redirecionando para /cart');
      window.location.href = '/cart';
    }

    trackAddToCart(item, quantity) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            items: [{
              item_id: item?.variant_id || item?.id || this.variantId,
              item_name: this.productCache ? this.productCache.title : this.productHandle,
              item_variant: this.selectedSize,
              price: this.selectedVariant ? (this.selectedVariant.price / 100) : null,
              quantity: quantity
            }]
          }
        });
        console.log('📊 GA4 tracking enviado');
      } catch (e) {
        console.warn('⚠️ Erro no tracking GA4:', e);
      }
    }

    animateProductToCart(quantity) {
      const productImage = document.querySelector('.product__main-photos img, .product-single__photos img');
      
      if (!productImage) {
        console.warn('⚠️ Imagem do produto não encontrada para animação');
        this.updateCartBadge(quantity);
        return;
      }

      // Criar clone da imagem
      const flyingImage = document.createElement('div');
      flyingImage.className = 'shopbar-flying-product';
      flyingImage.style.cssText = `
        position: fixed;
        z-index: 9999;
        width: 80px;
        height: 80px;
        border-radius: 8px;
        overflow: hidden;
        pointer-events: none;
        box-shadow: 0 8px 24px rgba(0,0,0,0.3);
      `;

      const imgClone = productImage.cloneNode();
      imgClone.style.cssText = `
        width: 100%;
        height: 100%;
        object-fit: cover;
      `;
      flyingImage.appendChild(imgClone);

      // Posição inicial (centro da tela, próximo à shopping bar)
      const startY = window.innerHeight - 120;
      const startX = window.innerWidth / 2 - 40;
      
      flyingImage.style.left = `${startX}px`;
      flyingImage.style.top = `${startY}px`;

      document.body.appendChild(flyingImage);

      // Encontrar posição do ícone do carrinho
      const cartIcon = document.querySelector('.cart-link, [data-cart-trigger], .site-nav__link--icon[href*="cart"]');
      
      if (!cartIcon) {
        console.warn('⚠️ Ícone do carrinho não encontrado');
        flyingImage.remove();
        this.updateCartBadge(quantity);
        return;
      }

      const cartRect = cartIcon.getBoundingClientRect();
      const endX = cartRect.left + (cartRect.width / 2) - 40;
      const endY = cartRect.top + (cartRect.height / 2) - 40;

      // Animar
      requestAnimationFrame(() => {
        flyingImage.style.transition = 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        flyingImage.style.transform = 'scale(0.3) rotate(20deg)';
        flyingImage.style.opacity = '0.8';
        flyingImage.style.left = `${endX}px`;
        flyingImage.style.top = `${endY}px`;
      });

      // Remover após animação e atualizar badge
      setTimeout(() => {
        flyingImage.style.opacity = '0';
        flyingImage.style.transform = 'scale(0) rotate(40deg)';
        
        setTimeout(() => {
          flyingImage.remove();
          this.updateCartBadge(quantity);
          this.pulseCartBadge();
        }, 200);
      }, 800);
    }

    async updateCartBadge(addedQuantity) {
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin'
        });
        
        if (!response.ok) throw new Error('Erro ao buscar carrinho');
        
        const cart = await response.json();
        const totalItems = cart.item_count;

        // Atualizar todos os badges do carrinho
        const badges = document.querySelectorAll('.cart-link__bubble-num, .cart-count, [data-cart-count]');
        
        badges.forEach(badge => {
          badge.textContent = totalItems;
        });

        // Mostrar badge se estava oculto
        const bubbles = document.querySelectorAll('.cart-link__bubble');
        bubbles.forEach(bubble => {
          if (totalItems > 0) {
            bubble.classList.add('cart-link__bubble--visible');
          }
        });

        console.log(`✅ Badge atualizado: ${totalItems} itens`);
        
      } catch (error) {
        console.error('❌ Erro ao atualizar badge:', error);
      }
    }

    pulseCartBadge() {
      const badges = document.querySelectorAll('.cart-link__bubble');
      
      badges.forEach(badge => {
        badge.style.animation = 'none';
        
        // Force reflow
        badge.offsetHeight;
        
        badge.style.animation = 'badge-pulse 0.6s ease-out';
        
        setTimeout(() => {
          badge.style.animation = '';
        }, 600);
      });
    }

  } // <-- FECHA A CLASSE ShopBar

  function initShopBar() {
    if (window.innerWidth > 768) {
      console.log('💻 Desktop: ShopBar não inicializado');
      return;
    }

    console.log('📱 Mobile: Inicializando ShopBar');
    new ShopBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopBar);
  } else {
    initShopBar();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const isMobile = window.innerWidth <= 768;
      const shopbar = document.querySelector('shopbar-component.denovo-shopbar');
      
      if (isMobile && shopbar && !shopbar._shopbarInitialized) {
        initShopBar();
        if (shopbar) shopbar._shopbarInitialized = true;
      }
    }, 250);
  });

})();

/* Adicionar animação de shake para quando não selecionar tamanho */
const style = document.createElement('style');
style.textContent = `
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-8px); }
    75% { transform: translateX(8px); }
  }
  
  @keyframes badge-pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
  }
`;
document.head.appendChild(style);